import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import { Icons } from "../../config/MuiIcons.config";
import Menu from "@mui/material/Menu";
import { AppGlobalContext } from "../../contexts/AppContext.context";
import "./ProfileMenu.style.css";
import { useMediaQuery } from "@mui/material";
// import { firebaseLogOut } from "../../services/authServices/auth.services";
import { AppTheme } from "../../theme/App.theme";
import { getRelativeRoleName } from "../../config/Roles.config";
import useLogoutHook from "../../hook/useLogoutHook";
// import { getUserRoleAndScreens } from "../../services/authServices/auth.services";

const ProfileMenu = () => {
  const navigate = useNavigate();
  const { authUserDetails } = useContext(AppGlobalContext);
  const { handleUserLogout } = useLogoutHook();

  const isMobileMid = useMediaQuery("(max-width:500px)");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    role: "",
    profileImage: ""
  });


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateUser = (path) => {
    navigate(path);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (authUserDetails && authUserDetails?.uid) {
      const { role, email, firstName, lastName, profileImage } = authUserDetails;
      setUserDetails({
        email: email || "Not Available",
        name: `${firstName} ${lastName}` || "Not Available",
        role: getRelativeRoleName(role) || "Not Available",
        profileImage: profileImage,
      })
    }
  }, [authUserDetails]);

  return (
    <React.Fragment>
      <div
        className="d-flex align-items-center"
        style={{
          borderRadius: "8px",
          border: `1px solid ${AppTheme.BORDER_COLOR}`,
        }}
      >
        <div
          className="d-flex align-items-center ms-auto"
          style={{ cursor: "pointer" }}
          onClick={(e) => handleMenu(e)}
        >
          <IconButton
            edge="end"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
            className="me-1"
            style={{ color: AppTheme.PRIMARY_COLOR, fontSize: "35px" }}
          >
            {userDetails?.profileImage ? (
              <Avatar
                src={userDetails.profileImage}
                sx={{ width: "33px", height: "33px" }}
              />
            ) : (
              <Icons.UserProfileIcon sx={{ width: "33px", height: "33px" }} />
            )}
          </IconButton>
          <div
            style={{
              display: isMobileMid ? "none" : "inline-block",
            }}
          >
            <Typography
              className="text-capitalize plus-jakarta-sans-semi-bold-600"
              style={{ fontSize: "16px" }}
            >
              {userDetails.name}
            </Typography>
            <Typography
              className="text-capitalize plus-jakarta-sans-light-300"
              style={{ fontSize: "12px" }}
            >
              {userDetails.role}
            </Typography>
          </div>
          <Icons.DownArrowAngleIcon
            className="mx-2"
            color="action"
            style={{ display: isMobileMid ? "none" : "initial" }}
          />
        </div>
      </div>

      {/* Profile Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        slotProps={{
          paper: {
            className: "menu-propover-class",
            sx: {
              "& .MuiMenu-list": {
                padding: 0,
              },
            },
          },
        }}
      >
        <div className="profile-main-div my-0">
          <div className="account-info-container">
            <div className="selected-account-wrapper py-2">
              <div className="account ps-3">
                <div className="selected-account-img">
                  <Typography
                    className="plus-jakarta-sans-medium-500"
                    variant="h6"
                  >
                    {userDetails.name?.charAt(0)?.toUpperCase()}
                  </Typography>
                </div>
                <div className="profile-info w-75">
                  <Typography
                    className="plus-jakarta-sans-medium-500 text-light text-capitalize"
                    variant="subtitle1"
                    style={{ fontSize: "15px" }}
                  >
                    {userDetails.name}
                  </Typography>
                  <Typography
                    className="plus-jakarta-sans-regular-400 text-light"
                    variant="caption"
                    noWrap
                  >
                    {userDetails.email}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <Divider
            style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
          />
          {/*  */}
          <div
            className="logout-section-container"
            onClick={() => navigateUser("/profile")}
          >
            <div className="account-logout-wrapper py-2">
              <div className="logout ps-3">
                <div>
                  <Icons.SettingsIcon sx={{ color: "GrayText", mr: 1 }} />
                </div>
                <div className="logout-text">
                  <Typography
                    className="plus-jakarta-sans-regular-400"
                    variant="subtitle1"
                  >
                    Manage Profile
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <Divider
            style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
          />
          <div className="logout-section-container" onClick={handleUserLogout}>
            <div className="account-logout-wrapper py-2">
              <div className="logout ps-3">
                <div>
                  <Icons.PowerSettingsNewIcon
                    sx={{ color: "GrayText", mr: 1 }}
                  />
                </div>
                <div className="logout-text">
                  <Typography
                    className="plus-jakarta-sans-regular-400"
                    variant="subtitle1"
                  >
                    Log Out
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Menu>
    </React.Fragment>
  );
};

export default ProfileMenu;
